(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .factory('ReporteModalService', ReporteModalService);

    ReporteModalService.$inject = ['$uibModal'];

    function ReporteModalService ($uibModal) {
        var service = {
        	proyectosAprobadosPorModalidad: proyectosAprobadosPorModalidad,
        	proyectosAprobadosPorModalidadFac: proyectosAprobadosPorModalidadFac,
        	proyectosAprobadosPorPerfilModalidad: proyectosAprobadosPorPerfilModalidad,
        	proyectosAprobadosPorPerfilModalidadFac: proyectosAprobadosPorPerfilModalidadFac,
        	proyectosPorDependenciaModalidadTipo: proyectosPorDependenciaModalidadTipo,
        	proyectosAprobadosPorArea: proyectosAprobadosPorArea,
        	proyectosAprobadosPorFuncion: proyectosAprobadosPorFuncion,
        	proyectosAprobadosConApoyoEconomico: proyectosAprobadosConApoyoEconomico,
        	proyectosAprobadosConApoyoEconomicoFac: proyectosAprobadosConApoyoEconomicoFac,
        	proyectosAprobadosPorDependenciaVigencia: proyectosAprobadosPorDependenciaVigencia, 
        	directorioDependencias: directorioDependencias,
        	prestadoresPorPerfil: prestadoresPorPerfil,
        	plazasDisponiblesAll: plazasDisponiblesAll,
        	plazasDisponibles: plazasDisponibles,
        	plazasDisponiblesByFac: plazasDisponiblesByFac,
        	prestadoresPorPerfilFac: prestadoresPorPerfilFac,
        	prestadoresPorDependenciaProyecto: prestadoresPorDependenciaProyecto,
        	bajasPrestadores: bajasPrestadores,
        	bajasPrestadoresFac: bajasPrestadoresFac,
        	proyectosPorPeriodo: proyectosPorPeriodo
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function proyectosAprobadosPorModalidad () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Modalidad (y Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos:null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorModalidadFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Modalidad'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos:null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorPerfilModalidad () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorPerfilModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Perfil y Modalidad'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: null,
                    programasEducativos: ['ProgramaEducativo', function(ProgramaEducativo) {
		                return ProgramaEducativo.all().$promise;
		            }],
		            sSEstatusProyecto: null

               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorPerfilModalidadFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorPerfilModalidadController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Perfil y Modalidad'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: null,
                    programasEducativos: ['ProgramaEducativo', function(ProgramaEducativo) {
		                return ProgramaEducativo.getByCurrentUser().$promise;
		            }],
		            sSEstatusProyecto: null

               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosPorDependenciaModalidadTipo () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosPorDependenciaModalidadTipoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos por Dependencia, Modalidad y Tipo (Aprobados y No Aprobados)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: ['SSEstatusProyecto', function(SSEstatusProyecto) {
		                return SSEstatusProyecto.all().$promise;
		            }]
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorArea () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorAreaController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Área Prioritaria de Desarollo con Prestadores'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorFuncion () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorFuncionController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Función en la que Inciden con Prestadores'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosConApoyoEconomico () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosConApoyoEconomicoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados con Apoyo Económico (por Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosConApoyoEconomicoFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosConApoyoEconomicoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados con Apoyo Económico'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function proyectosAprobadosPorDependenciaVigencia () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosAprobadosPorDependenciaVigenciaController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos Aprobados por Dependencia y Vigencia'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function directorioDependencias () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'DirectorioDependenciasController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Directorio de Dependencias que Registraron Proyectos'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function prestadoresPorPerfil () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPorPerfilController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Prestadores Asignados de Acuerdo al Perfil Solicitado (por Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function plazasDisponiblesAll () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPlazasDisponiblesAllController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos con plazas disponibles'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function plazasDisponibles () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPlazasDisponiblesController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos con plazas disponibles'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function plazasDisponiblesByFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPlazasDisponiblesController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos con plazas disponibles'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function prestadoresPorPerfilFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPorPerfilController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Prestadores Asignados de Acuerdo al Perfil Solicitado'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: null,
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function prestadoresPorDependenciaProyecto () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'PrestadoresPorDependenciaProyectoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Prestadores Asignados por Dependencia y por Proyectos de Acuerdo al Perfil'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    sSAmbitos: ['SSAmbito', function(SSAmbito) {
                        return SSAmbito.query().$promise;
                    }],
                    centrosDocentes: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function bajasPrestadores () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'BajasPrestadoresController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Bajas de Prestadores de Acuerdo al Perfil (por Facultad)'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.all().$promise;
                    }],
                    sSAmbitos: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
        
        function bajasPrestadoresFac () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'BajasPrestadoresController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Bajas de Prestadores de Acuerdo al Perfil'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    centrosDocentes: ['CentroDocente', function(CentroDocente) {
                        return CentroDocente.getByCurrentUser().$promise;
                    }],
                    sSAmbitos: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }

        function proyectosPorPeriodo () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/entities/s-s-reporte/reporte.html',
                controller: 'ProyectosPorPeriodoController',
                controllerAs: 'vm',
                resolve: {
                	reporte: function() {
                			return 'Proyectos por Periodo'
                	},
                    sSPeriodos: ['SSPeriodo', function(SSPeriodo) {
                        return SSPeriodo.all().$promise;
                    }],
                    centrosDocentes: null,
                    sSAmbitos: null,
                    programasEducativos: null,
		            sSEstatusProyecto: null
               }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
